import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ProfileService } from '../profile.service';
import { FormsModule, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FirstLetterUpperCase } from '../../shared/pipe/firstletteruppercase.pipe';
import { AuthService } from '../../auth/auth.service';
import { Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { LoggerService } from 'app/logger/logger.service';

// global const
const LETTERS_REGEX = /^[A-Za-z ]+$/;
const ZIPCODE_REGEX = /^[0-9]{5}(?:-[0-9]{4})?$/;
const PIN_REGEX = /^\d{4}$/;
const MOBILE_REGEX = /^\(\d{3}\)\s\d{3}\-\d{4}$|^\d{10}/;
// tslint:disable-next-line:max-line-length
const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

@Component({
    selector: 'app-account-setting',
    templateUrl: './account-setting.component.html',
    styleUrls: ['./account-setting.component.css']
})
export class AccountSettingComponent implements OnInit {
    // account setting form validation
    firstNameFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(LETTERS_REGEX)]);

    lastNameFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(LETTERS_REGEX)]);

    mobilePhoneFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(MOBILE_REGEX)]);

    billingAddress1FormControl = new FormControl('', [
        Validators.required]);

    cityFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(LETTERS_REGEX)]);

    zipCodeFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(ZIPCODE_REGEX)]);

    emailFormControl = new FormControl('', [
        Validators.pattern(EMAIL_REGEX)]);

    callCenterFormControl = new FormControl('', [
        Validators.required,
        Validators.pattern(PIN_REGEX)]);

    public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    // public variable define
    public preferred_contact_method;
    public preferred_language;
    public state;
    public billing_address_show: boolean;
    public first_name;
    public last_name;
    public billing_address;
    public billing_address_2;
    public city;
    public zip_code;
    public mobile_phone_number;
    public email;
    public call_center_auth_code;
    public account_setting_valid;
    public account_settings: Object;
    public service_address: Object;
    public component_load: boolean;
    // public is_email: boolean;
    public account_status: any;
    public user_type: any;
    public search_key: any;
    public account_number: any;
    public username: any;
    public pass_val: any;
    public searchByAgent: boolean;
    public showMailingAddress: boolean;
    public showEditMailingAddress: boolean;

    // methods = [
    //   { value: 'Mobile', viewValue: 'Mobile' },
    //   { value: 'Email', viewValue: 'Email' },
    //   { value: 'Both', viewValue: 'Both' }

    // ];

    states = [
        { value: 'AA', viewValue: 'AA' },
        { value: 'AE', viewValue: 'AE' },
        { value: 'AP', viewValue: 'AP' },
        { value: 'AL', viewValue: 'AL' },
        { value: 'AK', viewValue: 'AK' },
        { value: 'AZ', viewValue: 'AZ' },
        { value: 'AR', viewValue: 'AR' },
        { value: 'CA', viewValue: 'CA' },
        { value: 'CO', viewValue: 'CO' },
        { value: 'CT', viewValue: 'CT' },
        { value: 'DC', viewValue: 'DC' },
        { value: 'DE', viewValue: 'DE' },
        { value: 'FL', viewValue: 'FL' },
        { value: 'GA', viewValue: 'GA' },
        { value: 'HI', viewValue: 'HI' },
        { value: 'ID', viewValue: 'ID' },
        { value: 'IL', viewValue: 'IL' },
        { value: 'IN', viewValue: 'IN' },
        { value: 'IA', viewValue: 'IA' },
        { value: 'KS', viewValue: 'KS' },
        { value: 'KY', viewValue: 'KY' },
        { value: 'LA', viewValue: 'LA' },
        { value: 'ME', viewValue: 'ME' },
        { value: 'MD', viewValue: 'MD' },
        { value: 'MA', viewValue: 'MA' },
        { value: 'MI', viewValue: 'MI' },
        { value: 'MN', viewValue: 'MN' },
        { value: 'MH', viewValue: 'MH' },
        { value: 'MS', viewValue: 'MS' },
        { value: 'MO', viewValue: 'MO' },
        { value: 'MT', viewValue: 'MT' },
        { value: 'NE', viewValue: 'NE' },
        { value: 'NV', viewValue: 'NV' },
        { value: 'NH', viewValue: 'NH' },
        { value: 'NJ', viewValue: 'NJ' },
        { value: 'NM', viewValue: 'NM' },
        { value: 'NY', viewValue: 'NY' },
        { value: 'NC', viewValue: 'NC' },
        { value: 'ND', viewValue: 'ND' },
        { value: 'OH', viewValue: 'OH' },
        { value: 'OK', viewValue: 'OK' },
        { value: 'OR', viewValue: 'OR' },
        { value: 'PA', viewValue: 'PA' },
        { value: 'RI', viewValue: 'RI' },
        { value: 'SC', viewValue: 'SC' },
        { value: 'SD', viewValue: 'SD' },
        { value: 'TN', viewValue: 'TN' },
        { value: 'TX', viewValue: 'TX' },
        { value: 'UT', viewValue: 'UT' },
        { value: 'VT', viewValue: 'VT' },
        { value: 'VA', viewValue: 'VA' },
        { value: 'WA', viewValue: 'WA' },
        { value: 'WV', viewValue: 'WV' },
        { value: 'WI', viewValue: 'WI' },
        { value: 'WY', viewValue: 'WY' },


    ];

    languages = [
        { value: 'English', viewValue: 'English' },
        { value: 'Spanish', viewValue: 'Espa\u00F1ol' }
    ];

    constructor(private activatedRoute: ActivatedRoute, private dialog: MatDialog,
        private sharedService: SharedService, private localStorageService: LocalStorageService,
        private router: Router, private profileService: ProfileService, private logger: LoggerService, private datePipe: DatePipe,
        private authService: AuthService, @Inject(DOCUMENT) private document: Document) {
        this.pass_val = 'Change Password';
        this.sharedService.setHeaderTitle('default_page');
        this.service_address = {
            'zip_code': '', 'city': '', 'state': '', 'billing_address': '',
            'service_address': '', 'service_city': '', 'service_state': '', 'service_zip_code': '', 'esi_id': '', 'service_start_date': ''
        };
        if (this.localStorageService.get('token') != null) {
            this.sharedService.setLoader('account_setting', true);
            let methodName = this.constructor.name + '.verifyToken';
            this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
                .then(res => {
                    let logObj = {
                        method: methodName,
                        request: "token : [masked]",
                        response: res
                    };
                    this.logger.logInfo(JSON.stringify(logObj));
                    if (this.localStorageService.get('agentToken') !== null) {
                        this.searchByAgent = true;
                        this.pass_val = 'Reset Password';
                    }
                    if (res.status === 'success' && res.isTerminated === false) {
                        if (!res.isEnrolled) {
                            this.router.navigate(['./dashboard']);
                        } else {
                            const person = res.results[0]['personal'][0];

                            // Used for dataLayer.push
                            const dataLayerAccountInfo = res.results[0]['personal'];

                            var dataLayerEvent = 'account settings';
                            (window as any).dataLayer.push({ 'event': dataLayerEvent, 'accountID': dataLayerAccountInfo[0].id.toString(), 'accountNumber': dataLayerAccountInfo[0].accountNumber.toString() });

                            // if (res.isAccountSetting || this.searchByAgent) {
                            if (this.localStorageService.get('change_service_address') != null) {
                                this.dialog.open(ContactSupport);
                                this.localStorageService.remove('change_service_address');
                            }
                            this.component_load = true;
                            this.localStorageService.set('user_id', person['id']);
                            const service = res.results[0]['service'][0];
                            const that = this.sharedService;
                            setTimeout(function () {
                                that.setHeaderSuccessMessage('account_setting', false, '');
                                that.setHeaderErrorMessage('account_setting', false, 'notification error', '');
                                that.setHeaderTitleDynamicVal('account_setting', 'Account Information', '');
                                // that.setHeaderTitleDynamicVal('account_setting', 'Account Settings', 'Account Number ' + person['account_number']);
                            }, 10);
                            this.sharedService.setLoader('account_setting', false);
                            this.sharedService.setHeaderUserLoggedIn('account_setting', true, person);

                            if (service) {
                                this.service_address = service;
                            }

                            this.username = person['username'];
                            this.preferred_contact_method = person['preferedContactMethod'];
                            this.account_setting_valid = true;
                            this.first_name = person['firstName'];
                            this.last_name = person['lastName'];
                            this.billing_address = person['billingAddress'];
                            this.billing_address_2 = person['billingAddress2'];
                            this.city = person['city'];
                            this.state = person['state'];
                            this.zip_code = person['zipCode'];
                            this.billing_address_show = this.isBillingAddressSameAsServiceAddress();
                            this.mobile_phone_number = person['mobilePhoneNumber'];
                            this.email = person['email'];
                            this.account_status = person['accountStatusName'];
                            // if (this.email !== '') {
                            //   this.is_email = true;
                            // } 
                            // else {
                            //   this.methods = [
                            //     { value: 'Mobile', viewValue: 'Mobile' },
                            //   ];
                            // }
                            this.preferred_language = person['preferedLang'];
                            if (person['preferedLang'] == 'Espanol') {
                                this.preferred_language = 'Spanish';
                            }
                            this.call_center_auth_code = person['authCallMethod'];
                            if (this.call_center_auth_code === '') {
                                this.call_center_auth_code = person['dateOfBirth'].split('-')[1] + '/' + person['dateOfBirth'].split('-')[0];
                            }
                            // } else {
                            //     // This was taking users to the weird auth page that did not really work
                            //     // this.router.navigate(['./Profile/AccountSetting/SignIn']);
                            //     // replaced with normal account login page with returnUrl
                            //     this.localStorageService.remove('token');
                            //     this.localStorageService.set('returnUrl', 'Profile/AccountSetting');
                            //     this.router.navigate(['./sign-in']);
                            // }
                            // } else {
                            //   this.sharedService.setLoader('account_setting', false);
                            //   this.router.navigate(['./verify-contact-warning']);
                            //   // this.router.navigate(['./otp-verify/' + person['id']]);
                            // }
                        }
                    } else {
                        this.localStorageService.remove('token');
                        this.localStorageService.set('returnUrl', 'Profile/AccountSetting');
                        this.router.navigate(['./sign-in']);
                    }
                }, (error) => {
                    let logObj = {
                        method: methodName,
                        request: "token : [masked]",
                        exception: error
                    };
                    this.logger.logError(JSON.stringify(logObj));
                }).catch((ex) => {
                    let logObj = {
                        method: methodName,
                        request: "token : [masked]",
                        exception: ex
                    };
                    this.logger.logError(JSON.stringify(logObj));
                });
        } else {
            this.localStorageService.set('returnUrl', 'Profile/AccountSetting');
            this.router.navigate(['./sign-in']);
        }
    }

    isBillingAddressSameAsServiceAddress() {
        if (this.service_address['address'] == this.billing_address
            && this.service_address['address2'] == this.billing_address_2
            && this.service_address['city'] == this.city
            && this.service_address['state'] == this.state
            && this.service_address['zipCode'] == this.zip_code) {
            return true;
        } else {
            return false;
        }

    }

    // unmaskData(data: string) {
    //   return data.replace(/[\s\(\)\-]/g, '');
    // }

    // validate
    accountSettingValidate(event: any) {
        if (this.first_name !== '' && this.last_name !== '' && this.billing_address !== '' &&
            this.city !== '' && this.call_center_auth_code !== '' &&
            this.zip_code !== '' && this.zip_code !== undefined &&
            this.first_name !== undefined && this.last_name !== undefined &&
            this.billing_address !== undefined && this.city !== undefined &&
            this.call_center_auth_code !== undefined &&
            this.first_name.match(LETTERS_REGEX) && this.last_name.match(LETTERS_REGEX) &&
            this.zip_code.match(ZIPCODE_REGEX) && this.city.match(LETTERS_REGEX) &&
            this.call_center_auth_code.match(PIN_REGEX)) {
            this.account_setting_valid = true;
            if (event.keyCode === 13) {
                document.getElementById('btn-click').click();
            }
        } else {
            this.account_setting_valid = false;
        }

        // if(!this.billing_address_show){this.account_setting_valid = true;}

    }

    sameAsServiceAddress(event: any) {
        this.billing_address = this.service_address['address'];
        this.billing_address_2 = this.service_address['address2'];
        this.city = this.service_address['city'];
        this.state = this.service_address['state'];
        this.zip_code = this.service_address['zipCode'];

        this.accountSettingValidate(event);
    }

    // change password navigation
    changePassword() {
        if (this.searchByAgent) {
            const dialogRef = this.dialog.open(ResetPassword, {
                data: { username: this.username }
            });
        } else {
            this.router.navigate(['./Profile/AccountSetting/ChangePassword']);
        }
        /**this.authService.resetPassword({"username":this.mobile_phone_number})
        .then(res => {
            if(res.status == 'success'){
               //window.open(res.url, '_blank');
               this.router.navigate(['./change_password/'+res.results[0].id+'/'+res.results[0].token]);
            }else{
              this.sharedService.setHeaderErrorMessage("account_setting", true, "notification error", res.message);
            }
        });*/
    }

    updateEmail() {
        this.router.navigate(['./Profile/AccountSetting/UpdateEmail']);
    }

    refreshServiceLocation() {
        this.component_load = false;
        this.sharedService.setLoader('account_setting', true);
        this.profileService.refreshAccountByAgent({ 'token': this.localStorageService.get('token'), 'searchTerm': this.username })
            .then(response => {
                const person = response.results[0]['personal'][0];
                const service = response.results[0]['service'][0];
                this.account_number = person['accountNumber'];
                this.username = person['username'];
                this.localStorageService.set('username', this.username);
                this.sharedService.setLoader('account_setting', false);
                this.component_load = true;
                this.localStorageService.set('user_id', person['id']);
                this.sharedService.setHeaderTitleDynamicVal('account_setting', 'Account Information', '');
                // this.sharedService.setHeaderTitleDynamicVal('account_setting',
                //   'Account Settings', 'Account Number ' + person['account_number']);

                if (service) {
                    this.service_address = service;
                }

                this.preferred_contact_method = person['preferedContactMethod'];
                this.account_setting_valid = true;
                this.first_name = person['firstName'];
                this.last_name = person['lastName'];
                this.billing_address = person['billingAddress'];
                this.billing_address_2 = person['billingAddress2'];
                this.city = person['city'];
                this.state = person['state'];
                this.zip_code = person['zipCode'];
                this.billing_address_show = this.isBillingAddressSameAsServiceAddress();
                this.mobile_phone_number = person['mobilePhoneNumber'];
                this.email = person['email'];
                this.account_status = person['accountStatusName'];
                // if (this.email !== '') {
                //   this.is_email = true;
                // } 
                // else {
                //   this.methods = [
                //     { value: 'Mobile', viewValue: 'Mobile' },
                //   ];
                // }
                this.preferred_language = person['preferedLang'];
                if (person['preferedLang'] == 'Espanol') {
                    this.preferred_language = 'Spanish';
                }
                this.call_center_auth_code = person['authCallMethod'];
                if (this.call_center_auth_code === '') {
                    let dob = new Date(person['dateOfBirth'].trim());
                    this.call_center_auth_code = this.datePipe.transform(dob, "MMDD");
                    // this.call_center_auth_code = person['date_of_birth'].split('-')[1] + '/' + person['date_of_birth'].split('-')[0];
                }
            });
    }

    // save account setting
    accountSettingSave() {
        this.sharedService.setLoader('account_setting', true);
        this.sharedService.setHeaderSuccessMessage('account_setting', false, '');
        this.sharedService.setHeaderErrorMessage('account_setting', false, 'notification error', '');
        this.account_setting_valid = false;
        this.account_settings = {
            'firstName': this.first_name.trim(),
            'lastName': this.last_name.trim(),
            'billingAddress': this.billing_address,
            'billingAddress2': this.billing_address_2,
            'city': this.city.trim(),
            'state': this.state.trim(),
            'zipCode': this.zip_code,
            'preferredLanguage': this.preferred_language,
            'authCallMethod': this.call_center_auth_code,
            'token': this.localStorageService.get('token')
        };
        this.profileService.updateAccountSettings(this.account_settings).then(res => {
            this.account_setting_valid = true;
            window.scrollTo(0, 0);
            if (res.status === 'success') {
                this.sharedService.setHeaderSuccessMessage('account_setting', true, res.message);
                const this_obj = this;
                setTimeout(function () {
                    this_obj.sharedService.setHeaderSuccessMessage('account_setting', false, '');
                }, 5000);
            } else {
                if (res.type === 'timeup') {
                    this.router.navigate(['./Profile/AccountSetting/SignIn']);
                } else {
                    window.scrollTo(0, 0);
                    this.sharedService.setHeaderErrorMessage('account_setting', true, 'notification error', res.message);
                }
            }
            this.sharedService.setLoader('account_setting', false);
        });
    }

    ngOnInit() {
        const len = document.getElementsByTagName('body')[0];
        len.classList.add('fix-overlay-div');
    }

    changeMobile() {
        this.dialog.open(ChangeMobileNumber);
        /*const dialogRef = this.dialog.open(ChangeMobileNumber, {
             data: { type: this.user_type}
         });*/
    }

    contactSupport() {
        this.dialog.open(ContactSupport);
    }

    changeMailingAddress() {
        const dialogRef = this.dialog.open(ChangeMailingAddress);
        dialogRef.afterClosed().subscribe(isChange => {
            if (isChange != undefined) {
                this.showEditMailingAddress = isChange;
            }
        });
    }
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'contact-support',
    // tslint:disable-next-line:max-line-length
    template: `<div class="dialog-main"><button mat-icon-button class="dialog-close-btn" [mat-dialog-close]="true"><mat-icon>&#xE5CD;</mat-icon></button><div class="dialog-info"><h3 class="text-center">Contact Support</h3><p>Call <a href="javascript:void(0)">888.764.6669</a> or <a href="javascript:void(0)" (click)="chat()">Chat</a> with us to get help making this change to your account.</p></div></div><div class="footer"><button mat-button class="double-block-btn">Call 888.764.6669</button><button mat-button  class="single-btn" (click)="chat()">Chat</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ContactSupport {
    constructor(private dialog: MatDialog, private sharedService: SharedService) {
    }
    chat() {
        let chat_fab = (document.getElementById('chat_fab') as HTMLElement);
        if (chat_fab) {
            chat_fab.click();
        }
        this.dialog.closeAll();
        // if ((window as any).fcWidget.isOpen() != true) {
        //   (window as any).fcWidget.open();
        // }
        // const class_chat = document.getElementById('lc_chat_layout');
        // if (class_chat.classList.contains('lc-collapsed')) {
        //   const len = document.getElementById('lc_chat_header');
        //   len.click();
        // }
    }
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'change-mailing-address',
    // tslint:disable-next-line:max-line-length
    template: `<div class="dialog-main"><h3 class="text-center">Change Mailing Address</h3><p>Changing your mailing address does not change your service address.  Please call <a href="tel:888-764-6669">888-764-6669</a> or <a href="javascript:void(0)" (click)="chat()">Chat</a> with us to get help making a service address change to your account.</p></div><div class="footer" style=" display: flex;"><button mat-button class="double-block-btn border-b-none dialog-btn-border-r" [mat-dialog-close]="true" (click)="cancelChangeMailingAddress()">Cancel</button><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="continueChangeMailingAddress()">Continue</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ChangeMailingAddress {
    constructor(private dialog: MatDialogRef<ChangeMailingAddress>, private sharedService: SharedService) {
    }

    continueChangeMailingAddress() {
        this.dialog.close(true);
    }

    cancelChangeMailingAddress() {
        this.dialog.close(false);
    }

    chat() {
        let chat_fab = (document.getElementById('chat_fab') as HTMLElement);
        if (chat_fab) {
            chat_fab.click();
        }
        this.dialog.close(false);
        // if ((window as any).fcWidget.isOpen() != true) {
        //   this.dialog.close(false);
        //   (window as any).fcWidget.open();
        // }
    }
}


@Component({
    // tslint:disable-next-line:component-selector
    selector: 'change-mobile',
    // tslint:disable-next-line:max-line-length
    template: `<div class="dialog-main"><h3 class="text-center">Changing your mobile phone number</h3><p>By changing the mobile phone number associated with your account,you will also sign in to your account using the updated phone number going forward. Also, notifications will be sent to this number</p></div><div class="footer" style=" display: flex;"><button mat-button class="double-block-btn border-b-none dialog-btn-border-r" [mat-dialog-close]="true">Cancel</button><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="continueChangeNumber()">Continue</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ChangeMobileNumber {
    // tslint:disable-next-line:max-line-length
    public type: any;
    constructor(private activatedRoute: ActivatedRoute, private dialog: MatDialog, private sharedService: SharedService, private localStorageService: LocalStorageService, private router: Router, public dialogRef: MatDialogRef<ChangeMobileNumber>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }
    continueChangeNumber() {
        window.scrollTo(0, 0);
        this.router.navigate(['./Profile/AccountSetting/ChangePhoneNumber/' + this.localStorageService.get('user_id')]);
    }
}

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'reset-password',
    // tslint:disable-next-line:max-line-length
    template: `<div class="dialog-main"><h3 class="text-center">Reset Password</h3><p>Are you sure you want to reset password?</p></div><div class="footer" style=" display: flex;"><button mat-button class="double-block-btn border-b-none dialog-btn-border-r" [mat-dialog-close]="true">Cancel</button><button mat-button class="double-block-btn" [mat-dialog-close]="true" (click)="resetPassword()">Continue</button></div>`,
})
// tslint:disable-next-line:component-class-suffix
export class ResetPassword {
    // tslint:disable-next-line:max-line-length
    public reqdata: any;
    constructor(private profileService: ProfileService, private activatedRoute: ActivatedRoute, private dialog: MatDialog, private sharedService: SharedService, private localStorageService: LocalStorageService, private router: Router, public dialogRef: MatDialogRef<ResetPassword>, @Inject(MAT_DIALOG_DATA) public data: any) {
        this.reqdata = this.data;
    }
    resetPassword() {
        this.profileService.resetPassword(this.reqdata).then(res => {
            window.scrollTo(0, 0);
            if (res.status === 'success') {
                this.sharedService.setHeaderSuccessMessage('account_search_setting', true, res.message);
                const this_obj = this;
                setTimeout(function () {
                    this_obj.sharedService.setHeaderSuccessMessage('account_search_setting', false, '');
                }, 5000);
            } else {
                this.sharedService.setHeaderErrorMessage('account_search_setting', true, 'notification error', res.message);
            }
        });
    }
}









// WEBPACK FOOTER //
// ./src/app/profile/account-setting/account-setting.component.ts